import React from "react"
import { useState } from "react"
import { OverlayTrigger, Tooltip } from "react-bootstrap"

export const TimedTooltip = (prop: { text: string, icon?: React.ReactNode, childeren?: React.ReactNode  }) => {
  const text = prop.text
  const icon = prop.icon ?? ""
  const [tooltipIsOpen, setToolTipIsOpen] = useState(false)

  const toggleToolTip = () => {
    setToolTipIsOpen(true)
    setTimeout(() => {
      setToolTipIsOpen(false)
    }, 2000);
  }

  return (
    <OverlayTrigger
      trigger={['click', 'hover', 'focus']}
      show={tooltipIsOpen}
      delay={{ hide: 200, show: 200 }}
      overlay={(props) => (
        <Tooltip {...props}>
          {text}
        </Tooltip>
      )}
      placement="top">
      <div onClick={() => toggleToolTip()} >
        {icon && <div className="tooltip-alignment " onMouseOver={() => toggleToolTip()}>{icon}</div>}
        {prop.childeren && <div className="tooltip-alignment " onMouseOver={() => toggleToolTip()}>{prop.childeren}</div>}
      </div>
    </OverlayTrigger>
  )
}